import React, { useState, useEffect } from 'react'
import { Pie } from 'react-chartjs-2'
import { addCommas } from './../../addComas'
import { sortData } from './../../addComas'
import { db } from './../../Firebase'
import CircularProgress from '@material-ui/core/CircularProgress';


function Sectores({ phone }) {

    //Poner la data en un objeto
    const [chartData, setChartData] = useState({})
    const [Data, setData] = useState(null)
    const [fecha, setFecha] = useState(null)
    //Carga la data
    useEffect(() => {
        db.collection('Pruebas').doc('INV')
            .collection('SECTORES').doc('data')
            .onSnapshot(snapshot => {
                setData(sortData(snapshot.data()))
            });
        //Cargar fecha actualización
        db.collection('Pruebas').doc('INV')
            .onSnapshot(snapshot => {
                setFecha(snapshot.data()['Fecha'])
            });

    }, [])


    useEffect(() => {
        Data &&
            setChartData({

                datasets: [{
                    data: Object.values(Data),
                    label: "Cifras 2015-2020",
                    backgroundColor: ["#004777", "#A30000", "#FF7700", "#EFD28D", "#00AFB5"
                        ,
                        '#A6D8D4', '#8EAF9D', '6B7D7D']
                }],
                labels: Object.keys(Data),

            })
    }, [Data])



    //Opciones de la grafica
    const options = {
        legend: {
            display: !phone,
            position: 'left',
            fullWidth: true,
            align: 'start',
            labels: {
                padding: 5,
                fontSize: 10
            }

        },
        plugins: {
            datalabels: {
                display: !phone,
                color: "#FFF",
                align: 'end',
                formatter: (value) => { return addCommas(value) }
            },
        },
        responsive: true,
        elements: {
            arc: {
                borderWidth: 2,
                borderColor: '#111111'
            }
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                    return data.labels[tooltipItem.index] + ' : ' +
                        addCommas(data.datasets[0].data[tooltipItem.index]);
                }
            }
        }
    }




    return (
        <div className="chart-inv-pie">


            <h3 className="chart-title">
                Sectores No Minero Energéticos (USD millones)
                </h3>
            {Data ? (
                [<Pie data={chartData} options={options} />,
                <strong>Cifras {fecha && fecha}</strong>]

            ) : (
                    <CircularProgress style={{ color: 'green' }} />
                )}
        </div>
    )
}

export default Sectores
